import { Flex, LoadingIndicator, Typography } from '@aloft/toolkit-sui';

import { ContentfulDocument } from '../../../../components/ContentfulDocument/ContentfulDocument.js';
import { useSidebarUpdates } from '../../hooks/useSidebarUpdates.js';
import { Update } from './Update.js';

export function ContentfulUpdatesList() {
  const { updates = [], isLoading, isError } = useSidebarUpdates();

  if (isLoading) {
    return <LoadingIndicator message="Loading updates..." />;
  }

  if (isError) {
    return (
      <Typography>
        We're sorry, there was an error getting the latest updates. Please check back later.
      </Typography>
    );
  }

  return (
    <Flex flexDirection="column" gap=".75rem">
      {updates.map((update) => {
        return (
          <Update key={update.sys.id} title={update.fields.title}>
            <ContentfulDocument document={update.fields.content} />
          </Update>
        );
      })}
    </Flex>
  );
}
